import { useParams, useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import BannerListaDriverPage from '../../../components/report/listaDriverPage/BannerListaDriverPage';
import ContainerListaDriverPage from '../../../components/report/listaDriverPage/ContainerListaDriverPage';
import { useReport } from '../../../api/hooks/useReport';
import { useComponents } from '../../../api/hooks/useComponents';
import RankingButton from '../../../components/report/listaDriverPage/RankingButton';
import { useEventsSearch } from '../../../api/hooks/useEventsSearch';

const VisualizzaDettaglioReport = () => {
  const { name } = useParams();
  const location = useLocation();
  const id = location.state?.id as string | undefined;

  const {
    report,
    loading: loadingReport,
    error: errorReport,
  } = useReport(id);

  const {
    components: drivers,
    loading: loadingComponents,
    error: errorComponents,
  } = useComponents(id);

  // ✅ Memoizza il payload per evitare loop infinito
  const payload = useMemo(() => ({ report_id: id }), [id]);

  const { events } = useEventsSearch(payload);

  // Se uno dei due è in loading, mostra il loader
  if (loadingReport || loadingComponents) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
      </div>
    );
  }

  // Se uno dei due ha errori, mostra errore
  if (errorReport || errorComponents) {
    return (
      <div className="text-red-600">
        {errorReport ?? errorComponents}
      </div>
    );
  }

  return (
    <div className="flex flex-col bg-gray-50">
      <BannerListaDriverPage report={report} />

      <div className="px-8 lg:px-16 py-8">
        <div className="flex justify-end mb-4">
          <RankingButton report={report} drivers={drivers} />
        </div>

        <ContainerListaDriverPage
          drivers={drivers}
          reportId={name}
          id={id!}
          events={events}
        />
      </div>
    </div>
  );
};

export default VisualizzaDettaglioReport;
